import { BetVm } from './BetVm';
import { SportsbookComparisonItemVm } from './SportsbookComparisonItemVm';
import { parseWager } from '../helper/currencyFormatter';

export class StraightComparisonVm {
    totalWager: number;
    sortedComparisonList: SportsbookComparisonItemVm[]; // Array to hold sorted sportsbooks by highest to lowest 'to win'

    constructor(bets: BetVm[]) {
        this.totalWager = this.calculateTotalWager(bets);
        this.sortedComparisonList = this.calculateTotalToWin(bets);
    }

    private calculateTotalWager(bets: BetVm[]): number {
        return bets.reduce((sum, bet) => {
            const wager = parseWager(String(bet.straightWager));
            if (isNaN(wager)) {
                console.error(`Invalid wager value for bet: ${bet.straightWager}`);
            }
            return sum + wager;
        }, 0);
    }

    private calculateTotalToWin(bets: BetVm[]): SportsbookComparisonItemVm[] {
        const sportsbookToWin: { [key: string]: SportsbookComparisonItemVm } = {};

        // Initialize toWin for each sportsbook
        bets.forEach((bet) => {
            bet.comparisonBets.forEach((bettingSide) => {
                const sportsbookKey = bettingSide.sportsbook.sportsbookFeedKey;
                if (!sportsbookToWin[sportsbookKey]) {
                    sportsbookToWin[sportsbookKey] = new SportsbookComparisonItemVm(bettingSide.sportsbook, 0);
                }
            });
        });

        // Calculate total toWin (profit) amounts
        bets.forEach((bet) => {
            Object.keys(sportsbookToWin).forEach(sportsbookKey => {
                const bettingSide = bet.comparisonBets.find(bs => bs.sportsbook.sportsbookFeedKey === sportsbookKey);
                if (bettingSide) {
                    const wager = parseWager(String(bet.straightWager));
                    if (isNaN(wager)) {
                        console.error(`Invalid wager value for bet: ${bet.straightWager}`);
                    }
                    const oddsDecimal = parseFloat(String(bettingSide.oddsDecimal));
                    if (isNaN(oddsDecimal)) {
                        console.error(`Invalid odds value for betting side: ${bettingSide.oddsDecimal}`);
                    }
                    const payout = oddsDecimal * wager;
                    const toWin = payout - wager; // Calculate profit
                    sportsbookToWin[sportsbookKey].toWin += parseFloat(toWin.toFixed(2)); // Fix to two decimal places
                }
            });
        });

        // Convert to sorted array
        return Object.values(sportsbookToWin).sort((a, b) => b.toWin - a.toWin);
    }

    public getSortedComparisonList(): SportsbookComparisonItemVm[] {
        return this.sortedComparisonList;
    }
}
